import { Injectable } from '@angular/core';
import { Energietraeger } from '../../domain/model/energietraeger';
import { Energieart } from '../../domain/model/energieart.enum';

@Injectable({
    providedIn: 'root',
})
export class EnergietraegerEnergieartMatcherService {

    constructor() { }

    public doesEnergietraegerMatchEnergieart(energietraeger: Energietraeger, energieart: Energieart): boolean {
        if (energieart == Energieart.BHKW) {
            // As discussed in #178653284 is [Energieart.BHKW] an edge case and allowed on all [Energietraeger]
            return true;
        }
        switch (energietraeger) {
            case Energietraeger.BIOMASSE: return energieart == Energieart.GASE_BIOMASSE;
            case Energietraeger.BRAUNKOHLE: return energieart == Energieart.UNKNOWN;
            case Energietraeger.GASE_FOSSIL: return energieart == Energieart.UNKNOWN;
            case Energietraeger.GASE_ERDGAS: return energieart == Energieart.GASE_BIOMASSE;
            case Energietraeger.STEINKOHLE: return energieart == Energieart.UNKNOWN;
            case Energietraeger.MINERALOEL: return energieart == Energieart.UNKNOWN;
            case Energietraeger.GEOTHERMIE: return energieart == Energieart.GEOTHERMIE;
            case Energietraeger.PUMPSPEICHER: return energieart == Energieart.WASSER;
            case Energietraeger.LAUFWASSER: return energieart == Energieart.WASSER;
            case Energietraeger.SPEICHERWASSER: return energieart == Energieart.WASSER;
            case Energietraeger.KERNENERGIE: return energieart == Energieart.UNKNOWN;
            case Energietraeger.GASE: return energieart == Energieart.GASE_BIOMASSE;
            case Energietraeger.SOLAR: return energieart == Energieart.SOLAR;
            case Energietraeger.ABFALL: return energieart == Energieart.UNKNOWN;
            case Energietraeger.WINDENERGIE_OFFSHORE: return energieart == Energieart.WIND;
            case Energietraeger.WINDENERGIE_ONSHORE: return energieart == Energieart.WIND;
            case Energietraeger.SONSTIGES: return energieart == Energieart.UNKNOWN;
            case Energietraeger.BATTERIESPEICHER: return energieart == Energieart.UNKNOWN;
        }
        return false;
    }

    public getMatchingEnergieart(energietraeger: Energietraeger): Energieart {
        switch (energietraeger) {
            case Energietraeger.BIOMASSE: return Energieart.GASE_BIOMASSE;
            case Energietraeger.BRAUNKOHLE: return Energieart.UNKNOWN;
            case Energietraeger.GASE_FOSSIL: return Energieart.UNKNOWN;
            case Energietraeger.GASE_ERDGAS: return Energieart.GASE_BIOMASSE;
            case Energietraeger.STEINKOHLE: return Energieart.UNKNOWN;
            case Energietraeger.MINERALOEL: return Energieart.UNKNOWN;
            case Energietraeger.GEOTHERMIE: return Energieart.GEOTHERMIE;
            case Energietraeger.PUMPSPEICHER: return Energieart.WASSER;
            case Energietraeger.LAUFWASSER: return Energieart.WASSER;
            case Energietraeger.SPEICHERWASSER: return Energieart.WASSER;
            case Energietraeger.KERNENERGIE: return Energieart.UNKNOWN;
            case Energietraeger.GASE: return Energieart.GASE_BIOMASSE;
            case Energietraeger.SOLAR: return Energieart.SOLAR;
            case Energietraeger.ABFALL: return Energieart.UNKNOWN;
            case Energietraeger.WINDENERGIE_OFFSHORE: return Energieart.WIND;
            case Energietraeger.WINDENERGIE_ONSHORE: return Energieart.WIND;
            case Energietraeger.SONSTIGES: return Energieart.UNKNOWN;
            case Energietraeger.BATTERIESPEICHER: return Energieart.UNKNOWN;
        }
        return Energieart.UNKNOWN;
    }
}
